import EzLink from './EzLink';
export { isAnchor, isLink } from './utils';
export default EzLink;